import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string;

if (import.meta.env.PROD) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: true,
    track_pageview: true,
    ignore_dnt: true,
    persistence: 'localStorage',
  });
}

export default mixpanel;
